import DywRemoveNotification from './DywRemoveNotification';
import DywRemoveNotificationContainer from './DywRemoveNotification.container';

export default DywRemoveNotificationContainer(DywRemoveNotification);
